import React, { useState, useRef, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { ROUTES } from '../data/constants';
import { useAuth } from '../auth/useAuth';
import '../styles/Navbar.css';

interface NavbarProps {
  cartIcon?: React.ReactNode;
}

const Navbar: React.FC<NavbarProps> = ({ cartIcon }) => {
  const { isAuthenticated, user, login, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to={ROUTES.HOME} className="navbar-brand">
          <img
            src="/images/furever-logo-white.png"
            alt="FurEver"
            className="navbar-logo-img"
          />
        </Link>

        <div className="navbar-links">
          <NavLink to={ROUTES.PRODUCTS} className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
            Products
          </NavLink>
          <NavLink to={ROUTES.REVIEWS} className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
            Reviews
          </NavLink>
          {isAuthenticated && user?.isAdmin && (
            <>
              <NavLink to="/admin" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                Admin
              </NavLink>
              <NavLink to="/admin/agent-dashboard" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                Agent Demo
              </NavLink>
            </>
          )}
        </div>

        <div className="navbar-auth">
          {cartIcon}
          {isAuthenticated && user ? (
            <div className="user-menu" ref={menuRef}>
              <button
                className="user-menu-trigger"
                onClick={() => setMenuOpen(!menuOpen)}
                type="button"
              >
                <span className="user-avatar">
                  {user.name.charAt(0).toUpperCase()}
                </span>
                <span className="user-name">{user.name.split(' ')[0]}</span>
              </button>
              {menuOpen && (
                <div className="user-menu-dropdown">
                  <div className="user-menu-header">
                    <strong>{user.name}</strong>
                    <span className="user-menu-email">{user.email}</span>
                    {user.isAdmin && <span className="user-menu-badge">Admin</span>}
                  </div>
                  <hr className="user-menu-divider" />
                  <Link to="/orders" className="user-menu-item" onClick={() => setMenuOpen(false)}>
                    My Orders
                  </Link>
                  <button className="user-menu-item" onClick={() => { setMenuOpen(false); logout(); }}>
                    Sign out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <span className="nav-link" onClick={login} role="button" tabIndex={0}>Log in</span>
              <span className="nav-link nav-link--cta" onClick={login} role="button" tabIndex={0}>Sign up</span>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
